import { Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import FullPageLoader from '@components/general/loader/full-page-loader.component';
import { useZoomOauth } from '@services/query-services/lambda.query-service';
import { useUserStore } from '@store/app.store';
import { useStyledToast } from '@util/hooks';

function ZoomUserCallbackPage() {
  const user = useUserStore((state) => state.user);
  const setUser = useUserStore((state) => state.setUser);
  const { mutateAsync: zoomOauth } = useZoomOauth();
  const navigate = useNavigate();
  const toast = useStyledToast();

  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  async function authorize(code) {
    await zoomOauth(
      { person_id: user?.id, code },
      {
        onSuccess: () => {
          // 'store' the access token locally. We don't actually use the access
          // token here on the FE, this just lets the app know that the user
          // has connected and can start to use the zoom app functionality
          setUser({ ...user, zoom_config: { access_token: 'success' } });
          toast({ title: 'Zoom connected successfully.', status: 'success' });
        },
        onError: () =>
          toast({
            status: 'error',
            title: 'Something went wrong. You might already have Zoom connected.'
          })
      }
    );

    navigate('/agenda');
  }

  useEffect(() => {
    if (code && user) authorize(code);
  }, [code, user]);

  return (
    <FullPageLoader>
      <Text>Connecting Your Zoom Account...</Text>
    </FullPageLoader>
  );
}

export default ZoomUserCallbackPage;
